const base64ToBlob = (base64: string, contentType = "", sliceSize = 512): Blob => {
  try {
    // Remove the data URL prefix if it exists
    const base64Data = base64.includes(",") ? base64.split(",")[1] : base64;
    
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  } catch (error) {
    console.error("Error decoding Base64:", error);
    return new Blob();
  }
};


export { base64ToBlob };
